/**
 * Разбор тела ответа для RTK Query.
 *
 * Инфраструктурные отказы (413 от nginx на большом комплекте, 502/504 при
 * перезапуске или долгом ответе) приходят HTML-страницей, а не JSON. Дефолтный
 * responseHandler RTK Query скармливает такое тело `JSON.parse` не глядя, и
 * юрист вместо «комплект слишком большой» видел
 * `SyntaxError: Unexpected token '<', "<html> <h"... is not valid JSON`.
 *
 * Поэтому смотрим content-type и синтезируем ту же форму, что отдаёт бэкенд
 * (`osnova-api/src/error.rs` → `{ error: { code, message } }`), чтобы UI читал
 * причину одинаково — ответил axum или nginx.
 *
 * Blob-эндпоинтов не касается: они задают свой responseHandler, а он перебивает
 * глобальный.
 */

const INFRA_MESSAGES: Readonly<Record<number, string>> = {
  413: 'Файлы слишком большие — сервер отклонил загрузку целиком. Загрузите комплект меньшими частями.',
  502: 'Сервер недоступен или перезапускается. Повторите через минуту.',
  503: 'Сервер временно недоступен. Повторите через минуту.',
  504: 'Сервер не успел ответить за отведённое время. Если это загрузка большого комплекта — попробуйте частями.',
};

export interface ApiErrorBody {
  error: { code: string; message: string };
}

export function infraError(status: number): ApiErrorBody {
  const message =
    INFRA_MESSAGES[status] ??
    (status >= 500
      ? `Внутренняя ошибка сервера (${status}). Попробуйте позже.`
      : `Запрос отклонён сервером (${status}).`);
  return { error: { code: `http_${status}`, message } };
}

export async function parseResponse(response: Response): Promise<unknown> {
  const isJson = (response.headers.get('content-type') ?? '').includes('application/json');
  const text = await response.text();

  if (isJson) {
    // Пустое тело (204, HEAD) — валидный ответ, JSON.parse на нём падает.
    return text ? JSON.parse(text) : null;
  }
  if (response.ok) return text;

  // Не-JSON и не-ok: тело — HTML-страница nginx или голый текст axum. Юристу оно
  // ничего не говорит, но в консоли нужно для диагностики.
  console.warn(`Не-JSON ответ ${response.status} от ${response.url}:`, text.slice(0, 200));
  return infraError(response.status);
}
